<template>
    <div class="add_all">
        <el-button size="mini" type="primary" plain @click="addAllToCar()" v-if="adminState==0 || adminState== 1 " :loading="loading">全部加入订购
        </el-button>
        <el-button size="mini" type="primary" plain @click="addAllToCar()" v-else :loading="loading">全部加入荐购</el-button>

    </div>
</template>

<script>
    import { Button, Message } from 'element-ui'
    import { addMoreOrder, shoppingCartnum } from '@/api/pages'
    import Cookies from 'js-cookie'
    import Axios from '@/api/diyaxios'
    import addCarBefore from "./addCarBefore";
    import popup from "../common/plugin/dialog/index.js";
    import { insertPoint } from '@/api/insertPoints'   //添加埋点

    export default {
        props: ['queryData', 'total'],
        components: {
            'el-button': Button
        },
        data() {
            return {
                loading: false,
                adminState: Cookies.get("adminState"),
            }
        },
        watch: {

        },
        created() {

        },
        mounted() {
            let vm = this;
        },
        methods: {
            beforeAddCar(obj) {
                return new Promise((resolve, reject) => {
                    let vm = this;
                    Axios.post('/goods/action/check', {
                        params: obj.goodsIds
                    }, {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }).then(res => {
                        vm.loading = false;
                        let datalist = res.data || {};
                        if (datalist.notDuplicateGoods && datalist.notDuplicateGoods.length == 0) {//无重复
                            resolve(obj)
                        } else {//有重复
                            vm.addBeforePop(obj, datalist, resolve);
                        }
                    }).catch(err => {
                        vm.loading = false;
                    });
                });
            },
            addBeforePop(obj, datalist, resolve) {
                let vm = this;
                vm.beforeAdd_pop = popup('<add-car-before @cancel="close" @submit="submit" :datalist="datalist"/>', {
                    option: {
                        title: "提示",
                        width: "700px"
                    },
                    popup: {
                        data() {
                            return {
                                datalist
                            };
                        },
                        components: {
                            addCarBefore
                        },
                        methods: {
                            submit(data) {
                                obj.goodsIds = data.goodsIdList;
                                resolve(obj)
                                vm.beforeAdd_pop.hide();
                            },
                            close(data) {
                                vm.loading = false;
                                vm.beforeAdd_pop.hide();
                            }
                        }
                    }
                }
                );
                vm.beforeAdd_pop.show();
            },
            addAllToCar() {
                var vm = this;
                if (!Cookies.get('token')) {
                    this.$router.push({ name: 'Login' })
                } else {
                    if (vm.total > 0) {
                        this.$confirm(`是否将检索的${vm.total}条数据全部加入购物车`, "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }).then(() => {
                            vm.loading = true;
                            vm.getGid();
                        }).catch(() => {

                        });
                    } else {
                        vm.$message({
                            message: '未检索到数据！',
                            type: 'info'
                        })
                    }
                }
            },
            getGid() {
                let vm = this,
                    params = JSON.parse(JSON.stringify(vm.queryData));
                params['size'] = vm.total;
                params['current'] = 1;
                params['onecolumn'] = 1;
                params.source = Cookies.get('source')
                Axios.post('/rmdsupport/action/search', { params: params }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => {
                    if (res.data.records.length > 0) {
                        let ids = [];
                        res.data.records.map((item, index) => {
                            ids.push(item.goodsId);
                        });
                        vm.toCar(ids);
                    }
                }).catch(res => {
                    vm.loading = false;
                })


            },
            //加收订
            toCar(goodsIdList) {
                let vm = this;
                var obj = {
                    goodsIds: goodsIdList,
                    userId: Cookies.get('UserID'),
                    source: Cookies.get('source'),
                    amount: 1
                }
                vm.beforeAddCar(obj).then(function (params) {
                    if (params.goodsIds && params.goodsIds.length > 0) {
                        vm.loading = true;
                        let args = JSON.parse(JSON.stringify(obj));
                        args.goodsIdList = obj.goodsIds;
                        addMoreOrder(args).then(res => {
                            if (res.status) {
                                vm.loading = false;
                                if (vm.adminState == 0 || vm.adminState == 1) {
                                    vm.$message({
                                        message: '加入购物车成功',
                                        type: 'success',
                                    });
                                } else if (vm.adminState == 2 || vm.adminState == 3 || vm.adminState == 4 || vm.adminState == 5) {
                                    vm.$message({
                                        message: '荐购成功',
                                        type: 'success'
                                    });
                                }
                                //添加“加入购物车”埋点
                                let doId = +localStorage.getItem('doId') + 1;
                                localStorage.setItem('doId', doId);
                                insertPoint(obj, 'click', 'shop', doId); //添加埋点
                                vm.getShopCarData();//刷新购物车数据
                                vm.$emit('return', res.status);
                            }else if(res.code == '10000'){
                                vm.$confirm('您还没有收货地址，需要设置收货地址才可以荐购，需要设置吗', '提示', {
                                    confirmButtonText: '前往设置',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    const router = this.$router.resolve({
                                        path: '/addressmanagement',
                                    })
                                    window.open(router.href)
                                }).catch(() => {

                                });
                            }
                        }).catch(res => {
                            vm.loading = false;
                        })
                    } else {
                        vm.loading = false;
                    }
                }).catch(err => {
                });

            },
            // 展示购物车数据
            async getShopCarData() {
                let vm = this,
                    data = {
                        userId: Cookies.get("UserID"),
                    };

                let res = await shoppingCartnum(data)
                if (res.code == '200') {
                    vm.$store.state.DataStorage.GoodLengthData = res.data;
                }
                // Axios.post('/shoppingCart/action/total', obj, {
                //     headers: {
                //         "Content-Type": "application/json",
                //         token: Cookies.get('token')
                //     }
                //     }
                // ).then(res => {

                //     vm.$store.state.DataStorage.GoodLengthData = res.data;
                // }).catch(err => {

                // });
            }


        }
    }
</script>

<style lang='scss'>

</style>


// WEBPACK FOOTER //
// src/components/AddCarAll.vue